import React from 'react';
import './IndustryTech.scss';

const IndustryTech = ({
  industryTechContent = {}
}) => {
  return (
    <section className="healthcare-tech">
      <div className="container">
        <h2 className="main-title">{industryTechContent.mainTitle}</h2>

        <div className="content-grid">
          <div className="left-column">
            <div className="image-wrapper">
              <img src={industryTechContent.leftImage} alt="Healthcare Technology" />
            </div>
            <div className="text-section">
              <h3>{industryTechContent.leftHeading}</h3>
              <p>{industryTechContent.leftParagraph}</p>
            </div>
          </div>

          <div className="right-column">
            <div className="card-wrapper">
              {industryTechContent.performanceItems.slice(0, 2).map((item, index) => (
                <div className="card" key={index}>
                  <img src={item.icon} alt="Performance Icon" className="card-icon" />
                  <div className="card-content">
                    <h4>{item.title}</h4>
                    <p>{item.description}</p>
                  </div>
                </div>
              ))}
            </div>
            <div className="card-wrapper">
                {industryTechContent.performanceItems.slice(2, 4).map((item, index) => (
                <div className="card" key={index}>
                  <img src={item.icon} alt="Performance Icon" className="card-icon" />
                  <div className="card-content">
                    <h4>{item.title}</h4>
                    <p>{item.description}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default IndustryTech; 